import axios from 'axios'
import Vue from 'vue'
import locale from 'browser-locale'

// if (mock) {console.log(mock)}

let language
if (!window.prwidget.language || window.prwidget.language === '') {
  language = locale()
  language = language.split('-')[0]
} else {
  language = window.prwidget.language
  language = language.split('-')[0]
}

let domain
if (!window.prwidget.domain || window.prwidget.domain === '') {
  domain = window.location.host
} else {
  domain = window.prwidget.domain
}

let page
if (!window.prwidget.page || window.prwidget.page === '') {
  page = window.location.pathname
} else {
  page = window.prwidget.page
}

let termId
if (!window.prwidget.termId || window.prwidget.termId === '') {
  termId = ''
} else {
  termId = window.prwidget.termId
}

let baseURL
if (!window.prwidget.baseURL || window.prwidget.baseURL === '') {
  baseURL = 'https://privacy.dataone.online'
} else {
  baseURL = window.prwidget.baseURL
}

let bkBaseUrl
if (!window.prwidget.bkBaseUrl || window.prwidget.bkBaseUrl === '') {
  bkBaseUrl = 'https://privacy.dataone.online'
} else {
  bkBaseUrl = window.prwidget.bkBaseUrl
}

let loaded = false
let term = {}

export const state = () => ({
  baseURL,
  loaded,
  ieMode: true, // no complex headers sent if true
  isAjax: false,
  error: {},
  hasError: false,
  term,
  ref: window.prwidget.ref,
  domain,
  page,
  ownerId: window.prwidget.ownerId,
  language,
  termId,
  mailSent: false
})

const mutations = {
  setTerm (s, p) { s.term = p },
  setMailSent (s, p) { s.mailSent = p },
  setLoaded (s, p) { s.loaded = p },
  setPage (s, p) { s.page = p },
  setDomain (s, p) { s.domain = p },
  isAjax (state, payLoad = false) {
    state.isAjax = payLoad
  },
  error (state, payLoad = null) {
    if (payLoad === null) {
      if (state.error !== null) {
        state.error = null
      }
    } else {
      Vue.set(state, 'error', payLoad)
    }
  },
  hasError (state, payLoad = false) {
    state.hasError = payLoad
  }

}

const instance = axios.create({
  baseURL: baseURL + '/api',
  timeout: 10000,
  headers: {'Content-Type': 'application/json'},
  withCredentials: true
})

const bkinstance = axios.create({
  baseURL: bkBaseUrl + '/api',
  timeout: 10000,
  headers: {'Content-Type': 'application/json'},
  withCredentials: true
})

export const actions = {
  init ({state}) {
    // console.dir(state)
    // empty
  },
  get ({commit, getters}, {url, options = {}}) {
    commit('isAjax', true)
    commit('error')
    commit('hasError')

    if (!options.headers) {
      options.headers = {}
    }

    return instance.get(url, options)
      .then(res => {
        commit('isAjax')
        return res
      })
      .catch(err => {
        console.dir(err)

        commit('isAjax')
        commit('error', err)
        commit('hasError', true)
        return Promise.reject(err)
      })
  },
  post ({commit, getters}, {url, data, options = {}, serverName = 'abs'}) {
    commit('isAjax', true)
    commit('error')
    commit('hasError')

    return instance.post(url, data, options)
      .then(res => {
        commit('isAjax')
        return res
      })
      .catch(err => {
        console.log(err)
        commit('isAjax')
        commit('error', err)
        commit('hasError', true)
        return Promise.reject(err)
      })
      .then(() => {
        commit('isAjax', true)
      })
      .catch(e => {
        console.log('---- try backup')
        return bkinstance.post(url, data, options)
          .then(res => {
            commit('isAjax')
            return res
          })
          .catch(err => {
            console.log(err)
            commit('isAjax')
            commit('error', err)
            commit('hasError', true)
            return Promise.reject(err)
          })
      })
  },
  load ({commit, dispatch, state}) {
    if (state.loaded) {
      return
    }

    const url = `/widgetreq`

    const params = {
      ownerId: state.ownerId,
      termId: state.termId,
      page: state.page,
      domain: state.domain,
      ref: state.ref,
      language: state.language
    }

    let pr = JSON.stringify(params)
    pr = encodeURI(btoa(pr))

    const options = {
      params: {_k: pr}
    }

    return dispatch('get', {url, options})
      .then(res => {
        let data = res.data

        for (let i = 0; i < data.paragraphs.length; i++) {
          data.paragraphs[i].scrolled = false
        }
        // if (data)
        commit('setTerm', data)
      })
  },
  send ({commit, dispatch, state}, data) {
    data.ref = state.ref
    data.domain = state.domain

    return dispatch('post', {url: '/widget/userrequest', data}, {root: false})
      .then(() => commit('setMailSent', true))
  }
}

const getters = {
  trackId: s => {
    const t = `do=${s.domain}&pg=${s.page}&ow=${s.ownerId}`
    return 'prvwdg' + btoa(encodeURI(t))
  },
  allFlags: s => {
    if (!s.term || !s.term.paragraphs) {
      return []
    }
    const flags = []
    for (let i = 0; i < s.term.paragraphs.length; i++) {
      let p = s.term.paragraphs[i]
      for (let j = 0; j < p.treatments.length; j++) {
        const {code, selected, mandatory} = p.treatments[j]
        flags.push({code, selected, mandatory, termId: s.termId})
      }
    }
    return flags
  },
  allMandatorySelected: s => {
    if (!s.term || !s.term.paragraphs) {
      return false
    }
    for (let i = 0; i < s.term.paragraphs.length; i++) {
      let p = s.term.paragraphs[i]
      for (let j = 0; j < p.treatments.length; j++) {
        let t = p.treatments[j]
        if (t.mandatory && !t.selected) {
          return false
        }
      }
    }

    return true
  },
  allScrolled: s => {
    if (!s.term || !s.term.paragraphs) {
      return false
    }
    for (let i = 0; i < s.term.paragraphs.length; i++) {
      let p = s.term.paragraphs[i]
      if (!p.scrolled) {
        return false
      }
    }

    return true
  },
  privacyIsValid: (s, g) => {
    if (!g.allScrolled) {
      return false
    }

    return g.allMandatorySelected
  }

}

export const store = {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store.js